import { Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core'
import { FormArray, FormBuilder, FormGroup } from '@angular/forms'
import * as lodash from 'lodash'
import { newRoleItemForm } from '../role-item-form/role-item-form.component'
import { SigningOrderEditorComponent } from '../signing-order-editor/signing-order-editor.component'
import { ContractTemplate, TemplateTypes } from '@tokeet-frontend/signature'

export function createAddSignersForm(formBuilder: FormBuilder): FormArray {
  return formBuilder.array([])
}

export function setAddSignersFormData(rolesForm: FormArray, template: ContractTemplate, editable = true) {
  const signers = template.signers || []

  rolesForm.clear()
  lodash.forEach(template.roles, (role) => {
    const settingsForRole = lodash.find(signers, ({ role: r }) => r === role)
    const idPhotoRequired = settingsForRole ? settingsForRole.id_photo_required : template.id_photo_required
    const selfiePhotoRequired = settingsForRole?.selfie_photo_required || false

    const roleForm = newRoleItemForm(rolesForm, {
      role,
      idPhotoRequired,
      selfiePhotoRequired,
      order: settingsForRole?.order,
    })
    if (!editable) {
      roleForm.disable()
    }
    rolesForm.push(roleForm)
  })
}

export function getSignersFormData(form: FormArray) {
  const data = form.getRawValue()
  return {
    roles: lodash.map(data, 'role'),
    signers: data,
  }
}

@Component({
  selector: 'app-add-roles-form',
  templateUrl: './add-roles-form.component.html',
  styleUrls: ['./add-roles-form.component.scss'],
})
export class AddRolesFormComponent implements OnInit, OnChanges {
  @Input() form: FormArray
  @Input() isRolesEditable: boolean = true
  @Input() templateType: TemplateTypes

  @ViewChild('signingOrder') signingOrder: SigningOrderEditorComponent

  templateTypes = TemplateTypes
  rolesLimit = 5

  constructor() {}

  ngOnInit(): void {
    if (!this.form.length) {
      this.onAddRole()
    }
  }

  ngOnChanges() {
    this.refreshForm()
  }

  refreshForm() {
    lodash.forEach(this.form.controls, (item: FormGroup) => {
      const roleCtrl = item.get('role')
      this.isRolesEditable ? roleCtrl.enable() : roleCtrl.disable()
    })
  }

  trackByIndex(index: any) {
    return index
  }

  onAddRole(role?: string) {
    this.form.push(newRoleItemForm(this.form, { order: this.signingOrder?.newOrderValue }))
    this.signingOrder?.refreshOrder()
  }

  onRoleSelect(role: string, roleForm: FormGroup) {
    const counts = lodash.countBy(this.form.getRawValue(), (r) => r.role)
    const getNewRole = (role: string, index: number) => {
      const roleStr = `${role} ${index}`
      if (counts[roleStr] > 0) {
        return getNewRole(role, index + 1)
      }
      return roleStr
    }
    setTimeout(() => {
      if (counts[role] > 1) {
        roleForm.patchValue({ role: getNewRole(role, counts[role]) })
      }
    })
  }

  onRemoveRole(index: number) {
    this.form.removeAt(index)
    this.signingOrder?.refreshOrder()
  }
}
